/**
 * Stylised anterior thigh — premium line illustration (no external asset).
 */
export function MuscleLegDiagram({ className = '' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 200 320"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        <linearGradient id="sciMuscleGrad" x1="100" y1="40" x2="100" y2="300" gradientUnits="userSpaceOnUse">
          <stop stopColor="currentColor" stopOpacity="0.35" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.08" />
        </linearGradient>
      </defs>
      <path
        d="M100 28c18 0 32 14 32 32v12l-6 210c-2 18-14 30-26 30s-24-12-26-30L68 72V60c0-18 14-32 32-32z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeOpacity="0.5"
        fill="url(#sciMuscleGrad)"
      />
      <path
        d="M82 120 Q100 108 118 120 M78 175 Q100 160 122 175 M76 230 Q100 215 124 230"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeOpacity="0.45"
        strokeLinecap="round"
      />
      <path
        d="M92 95 L100 265 M108 100 L100 265"
        stroke="currentColor"
        strokeWidth="1"
        strokeOpacity="0.25"
        strokeDasharray="4 6"
      />
      <ellipse cx="100" cy="52" rx="14" ry="10" stroke="currentColor" strokeWidth="1.2" strokeOpacity="0.4" fill="none" />
    </svg>
  );
}
